import { driver, type DriveStep } from 'driver.js';

export function createResortDriver(
  steps: DriveStep[],
  onComplete?: () => void,
): ReturnType<typeof driver> {
  return driver({
    animate: true,
    smoothScroll: true,
    allowClose: true,
    overlayColor: 'rgba(0, 0, 0, 0.62)',
    stagePadding: 8,
    stageRadius: 0,
    popoverClass: 'resort-driver-popover',
    popoverOffset: 12,
    showProgress: true,
    progressText: '{{current}} of {{total}}',
    nextBtnText: 'Next',
    prevBtnText: 'Back',
    doneBtnText: 'Done',
    showButtons: ['next', 'previous', 'close'],
    steps,
    onDestroyed: () => {
      onComplete?.();
    },
  });
}

/** Keep steps whose DOM targets exist so tours don't break on empty/loading screens. */
export function filterAvailableTourSteps(steps: DriveStep[]): DriveStep[] {
  if (typeof document === 'undefined') return steps;

  return steps.filter(step => {
    if (!step.element) return true;
    if (typeof step.element === 'string') {
      return document.querySelector(step.element) !== null;
    }
    if (typeof step.element === 'function') {
      try {
        return step.element() != null;
      } catch {
        return false;
      }
    }
    return true;
  });
}

export const RESORT_TOUR_HINT_PREFIX = 'resort-tour-hint-';

export function hasSeenTourHint(tourKey: string): boolean {
  if (typeof window === 'undefined') return true;
  return Boolean(localStorage.getItem(`${RESORT_TOUR_HINT_PREFIX}${tourKey}`));
}

export function markTourHintSeen(tourKey: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(`${RESORT_TOUR_HINT_PREFIX}${tourKey}`, '1');
}
